package com.snakesworld.game.engine

/**
 * Game balance tuning, physical simulation constants, and retro arcade palette tokens.
 */
object GameConstants {
    // Arena Boundaries (Square Arena: [-ARENA_HALF_SIZE, +ARENA_HALF_SIZE] on X and Y).
    // Half of the original 2000 half-size so full width/height are half of before.
    const val ARENA_HALF_SIZE: Float = 1000f

    // Snake Move Cadence (Snake moves in discrete steps every 0.25s, or 0.125s when sprint boosting)
    const val BASE_MOVE_INTERVAL_SECONDS: Float = 0.25f
    const val BOOST_SPEED_MULTIPLIER: Float = 2.0f

    // Snake Speed Dynamics
    // Constant base speed invariant to pellet consumption or mass growth!
    const val BASE_SNAKE_SPEED: Float = 220f

    // Initial Length & Segments (Every player starts with length 5 = 1 head + 4 body segments)

    const val INITIAL_SNAKE_BODY_SEGMENTS: Int = 4
    const val MIN_SNAKE_BODY_SEGMENTS: Int = 2

    // Mass is a score/growth counter only (length +1 per pellet). It never
    // changes cell size and never decides collisions.
    const val INITIAL_SNAKE_MASS: Float = 5f

    // Uniform aligned grid: every head, body segment, and pellet is one square.
    const val SEGMENT_SPACING: Float = 24f
    const val CELL_HALF_SIZE: Float = SEGMENT_SPACING / 2f // 24×24 draw + collide square

    // Collision & Grace Period
    // Skip only the immediate neck (the cell the head just left) so a 90° turn
    // cannot false-kill. Looping onto any older body cell is fatal.
    const val SELF_COLLISION_IGNORE_SEGMENTS: Int = 1

    // Pellets & Feeding

    const val BASE_PELLET_COUNT: Int = 18
    const val MAX_PELLET_COUNT: Int = 22
    const val PELLETS_PER_PLAYER: Int = 2

    // Heartbeat & Networking
    const val HEARTBEAT_STALE_THRESHOLD_MS: Long = 5000L

    // Retro 8-bit Arcade Color Palette
    const val COLOR_NEON_GREEN: Long = 0xFF00FF66
    const val COLOR_NEON_CYAN: Long = 0xFF00F0FF
    const val COLOR_NEON_MAGENTA: Long = 0xFFFF007F
    const val COLOR_NEON_YELLOW: Long = 0xFFFFEA00
    const val COLOR_NEON_ORANGE: Long = 0xFFFF6600
    const val COLOR_NEON_PURPLE: Long = 0xFF9D00FF
    const val COLOR_NEON_BLUE: Long = 0xFF0066FF
    const val COLOR_NEON_RED: Long = 0xFFFF1744

    val PELLET_PALETTE = listOf(
        COLOR_NEON_GREEN,
        COLOR_NEON_CYAN,
        COLOR_NEON_MAGENTA,
        COLOR_NEON_YELLOW,
        COLOR_NEON_ORANGE,
        COLOR_NEON_PURPLE,
    )
}
